import React, { ReactNode } from 'react'
import { NoCollaboIcon } from 'src/assets'
import styled from 'styled-components'
interface NocollaboProps {
  children: ReactNode
}
const NoCollaboWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  .text {
    padding-top: 68px;
  }
  .image {
    padding-top: 50px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      text-align: center;
    }
    img {
      width: 100%;
    }
  }
  p {
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 29px;
    color: ${({ theme }) => theme.colors.dark};
  }
`
const NoCollabo = ({ children }: NocollaboProps) => {
  return (
    <NoCollaboWrapper>
      <div className="text">
        <h4>{children}</h4>
      </div>
      <div className="image">
        <img src={NoCollaboIcon} alt="" />
      </div>
    </NoCollaboWrapper>
  )
}
export { NoCollabo }
